angular.module('picmonicng').directive('confidenceRating', [
  '$window',
  function ($window) {
    return {
      restrict: 'E',
      scope: {
        card: '=',
        location: '@',
      },
      transclude: true,
      link: function ($scope, element, attrs) {
        if ($scope.location == 'bottom' && $window.innerHeight < 720) {
          var childSpan = element.find('span.rating_block');
          childSpan.addClass('dropup');
        }

        $scope.rateCard = function (rating) {
          send_ga('event', 'Learn', 'Card Rated');
          $scope.card.rating = rating;
          $scope.card.$update();
        };

        $window.onresize = function (event) {
          var clientHeight = document.documentElement.clientHeight;
          if ($scope.location == 'bottom' && clientHeight < 720) {
            var childSpan = element.find('span.rating_block');
            childSpan.addClass('dropup');
          }
        };
      },
      templateUrl: '/templates/directives/confidence_rating.html',
    };
  },
]);
